import React, { useContext } from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';
import { INTERFACE } from 'pathnames.js';
import { SORT_ORDER } from 'globals.js';

// CORE COMPONENTS
import Form from 'core/form/Form';

// HELPERS
import { ListContext, getListData } from 'helpers/getListData';

// PARTS
import Main from 'parts/main/Main';
import Title from 'parts/title/Title';
import Table, { Filters } from 'parts/table/Table';

// LOCAL VARIABLES
import { COLUMNS as ACCOUNTING_COLUMNS } from './variables';
import { ACTIONS, COLUMNS } from 'columns';
import clsx from 'clsx';

// MAIN COMPONENT
const DealCount = () => {
  const { data, preferences } = useContext(ListContext) || {};

  return (
    <Main>
      <Title documentTitle="Accounting Tasks -> Deal Count" title="Deal Count" />
      <Filters>
        <Filters.Date.Range />
        <Filters.Button.SalesType />
        <Filters.Button.NewUsed />
        <Filters.Select.Match />
        <Filters.Search />
      </Filters>
      <Table
        heading={
          <span>
            Results for "Accounting Tasks -{' '}
            {preferences?.filters?.auditStatus === 'nomatches' ? 'No Matches' : preferences?.filters?.auditStatus} (
            {data?.total_records || 0})" | Backouts from Previous Months (
            <span className={clsx(data?.total_backout_records && 'text-danger')}>{data?.total_backout_records}</span>)
          </span>
        }
        mobilePreviewKeys={['customer1_full_name', 'sales_time', 'Vehicle']}
        showNumber
      />
    </Main>
  );
};

// EXPORT
export default getListData(DealCount, {
  key: 'accountTaskDealCount',
  fetchArgs: {
    endpoint: ENDPOINTS.AccountingTasks.deal_count.list
  },
  defaults: {
    startDate: Form.Date.OPTIONS.thisMonth.startDate,
    endDate: Form.Date.OPTIONS.thisMonth.endDate,
    salesType: 'R',
    auditStatus: 'nomatches',
    sort: 'sales_time',
    order: SORT_ORDER.ascending
  },
  columns: [
    {
      ...COLUMNS.deliveredDate,
      key: 'sales_time'
    },
    COLUMNS.ageOfVehicle,
    COLUMNS.customer(),
    COLUMNS.salesPerson,
    {
      ...COLUMNS.fmManager,
      key: 'fm_assignment_user_full_name'
    },
    {
      ...COLUMNS.makeModel,
      key: 'Vehicle'
    },
    ACCOUNTING_COLUMNS.vinNumber,
    ACCOUNTING_COLUMNS.stockNumber,
    ACCOUNTING_COLUMNS.dealNumber
  ],
  actions: [ACTIONS.open(INTERFACE.sales, 'sales_id')],
  sortable: true
});
